import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-personnel-hestory',
  templateUrl: './personnel-hestory.component.html',
  styleUrls: ['./personnel-hestory.component.css']
})
export class PersonnelHestoryComponent implements OnInit {
  title="Employee Record";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/personnel-details/Personnels/personnel-hestory/personnel-hestory.component.ts